// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3ZQDY","container":"styles_container__1Z_VH","title":"styles_title__1W_RV","wrapper":"styles_wrapper__1KN0V","answer":"styles_answer__3pXqN"};